module.exports = __webpack_public_path__ + "static/massdmg-logo-ac73835c36ba3a884c365293c607661d.png";